export enum Frequency {
  Weekly = 'WEEKLY',
  BiWeekly = 'BI_WEEKLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Monthly = 'MONTHLY',
}
